import React from 'react';
import classNames from 'classnames';
import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';

import './styles.scss';

interface Props {
  className?: string;
  stage: string;
  stageLabel: string;
}

export default function StageDotBadge({ className, stage, stageLabel }: Props) {
  return (
    <Badge
      appearance="muted"
      className={classNames('d-inline-flex align-items-center gap-1', className)}
      variant="outline"
    >
      <span className={classNames('apex-deal-stage-dot rounded-circle p-1', stage)} />
      {stageLabel}
    </Badge>
  );
}